import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import RegionForm from '../containers/RegionFormContainer';
import DocumentHead from '../../../../elements/components/DocumentHead';
import Logger from '../../../../../../lib/Logger';

class RegionAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `RegionAdd.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('region_route_add')} />
          <RegionForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RegionAddScreen;

Logger.log('silly', `RegionAddScreen loaded.`);
